module.exports = __webpack_public_path__ + "static/media/uploadImage.f01f3351.jpg";